var _s = $RefreshSig$();

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { useTranslation } from './useTranslation';
export function Translation(props) {
  _s();

  var ns = props.ns,
      children = props.children,
      options = _objectWithoutProperties(props, ["ns", "children"]);

  var _useTranslation = useTranslation(ns, options),
      _useTranslation2 = _slicedToArray(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}

_s(Translation, "t/1iBAGEdX8rDM6vi/jYf+ryVbo=", false, function () {
  return [useTranslation];
});

_c = Translation;

var _c;

$RefreshReg$(_c, "Translation");